export default {
  customers: [],
  customer: {}
}